module.exports = __webpack_public_path__ + "static/media/connector-logo_azure-data-factory.02e2a9ca.svg";